module.exports = __webpack_public_path__ + "static/media/373.33ebd9bb.png";